import { Table, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEdit, faCheck, faFilePdf, faFileZipper } from '@fortawesome/free-solid-svg-icons';

//Assets
import "../../assets/css/tabelaListagem.css";

//Components
import TextField from '../TextField';
import { downloadZip } from '../../helpers/downloadFile';
import { formatDataHora } from '../../helpers/formatDataHora';
export default function TabelaListagemFichas({ title, headers, items, visualizar, remover, editar, search, onChangeSearch = null, nameSearch = null, confirmar, scrollbar = true, width, conditionButton, widthPDF = "35%" }) {
    //Função que carrega os items da tabela
    function LoadItems() {
        return items.map((item, itemKey) => {

            //pegando os valores que vão ser listados na linha de acordo com os cabeçalhos enviados
            const values = headers.map(header => {
                if (header.objectValue) {
                    if (header.formatDate && !!item[header.objectValue]) {
                        return formatDataHora(item[header.objectValue])
                    }
                    if (header.objectValue == "anexos" && item?.anexos?.length > 0) {
                        const anexo = item.anexos[0];
                        const arquivo = anexo?.anexo;
                        const nomeOriginal = anexo?.nomeArquivoOriginal;
                        const extensao = arquivo?.split('.').pop()?.toLowerCase();

                        if (extensao === "pdf") {
                            return <div className='d-flex align-items-center justify-content-center'>
                                <div style={{ width: widthPDF }} className=' rounded-circle ratio ratio-1x1 bg-danger'>
                                    <a href={arquivo} download={nomeOriginal} target="_blank" className='d-flex align-items-center justify-content-center'>
                                        <FontAwesomeIcon icon={faFilePdf} color='#ffffff' />
                                    </a>
                                </div>
                            </div>
                        }

                        if (extensao !== "zip") {
                            return <a href={arquivo} download={nomeOriginal} target="_blank" rel="noopener noreferrer">
                                <img src={arquivo} alt={nomeOriginal ?? item.questao} height={50} width={50} className='rounded-pill' />
                            </a>
                        }

                        if (extensao === "zip") {
                            return <div className='d-flex align-items-center justify-content-center'>
                                <div style={{ width: widthPDF }} className='rounded-circle ratio ratio-1x1 bg-secondary'>
                                    <button
                                        className='d-flex align-items-center justify-content-center w-100 h-100 border-0 bg-transparent'
                                        onClick={() => downloadZip(item.base64, nomeOriginal ?? arquivo)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <FontAwesomeIcon icon={faFileZipper} color='#ffffff' />
                                    </button>
                                </div>
                            </div>
                        }
                    }

                    if (!!item["relator"] && item[header.objectValue] == item["usuario"]) {
                        return <>{item[header.objectValue]} (Relator)</>
                    }

                    return item[header.objectValue];
                }

            });

            return (
                <tr key={itemKey}>
                    {visualizar &&
                        <td className='text-center d-flex align-items-center justify-content-center'>
                            <Button style={{ borderRadius: "100%", display: "flex", alignItems: "center", justifyContent: "center", width: "35px", height: "35px" }} color='primary' onClick={(e) => visualizar(item)} id={`btnFicha${itemKey}`}>
                                <FontAwesomeIcon icon={faSearch} />
                            </Button>

                        </td>
                    }
                    {
                        confirmar
                            ?
                            <td className='text-center' >
                                <Button color='success' className=' fw-bold' onClick={() => {
                                    confirmar(item, itemKey)
                                }} id={`btnConfirmar${itemKey}`}>
                                    <FontAwesomeIcon icon={faCheck} style={{ color: "#fff" }} />
                                </Button>

                            </td>
                            :
                            <></>
                    }
                    {
                        remover &&
                        <td className='text-center' >
                            <Button color='danger' className=' fw-bold' onClick={() => {
                                remover(item, itemKey)
                            }} id={`btnRemover${itemKey}`}>
                                X
                            </Button>

                        </td>
                    }
                    {
                        conditionButton &&
                        conditionButton(item, itemKey)
                    }

                    {
                        editar &&
                        <td className='text-center' >
                            <Button color='info' className=' fw-bold' onClick={() => {
                                editar(item, itemKey)
                            }} id={`btnEditar${itemKey}`}>
                                <FontAwesomeIcon icon={faEdit} style={{ color: "#fff" }} />
                            </Button>

                        </td>
                    }

                    {values.map((valor, key) => {
                        return (
                            <td key={key}>
                                {
                                    valor
                                }
                            </td>
                        );
                    })}

                </tr>
            )

        })
    }
    return (
        <div className={`tabelaListagem ${width ? 'width w-' + width : ""} ${scrollbar ? "scrollbar" : ""}`}>
            {/*a opção scrollbar faz com que a tabela fique com a classe scrollbar limitando o width da tabela assim sendo necessario deixar esta opção como false nos relatorios para que a tabela ocupe a tela toda*/}
            <div className='d-flex justify-content-between align-items-center'>
                {title
                    ?
                    <h5 className='mt-2'>{title}</h5>
                    : <></>}
                {search
                    ? <TextField placeholder={search} icon={faSearch} onChange={onChangeSearch} name={nameSearch} />
                    : <></>
                }
            </div>
            <Table className='w-100' striped >
                <thead>
                    <tr>
                        {
                            visualizar || remover || confirmar || editar || conditionButton
                                ?
                                <th colSpan={visualizar && remover && editar && confirmar
                                    ? 4
                                    : visualizar && remover && confirmar || visualizar && editar && confirmar || editar && remover && confirmar
                                        ? 3
                                        : editar && remover || editar && confirmar || editar && visualizar || remover && confirmar || remover && visualizar || confirmar && visualizar
                                            ? 2
                                            : 1} className={"text-center "}>Açoes</th>
                                : <></>
                        }
                        {headers.map((header, key) => (<th key={key}>{header.value}</th>))}
                    </tr>
                </thead>
                <tbody>
                    {items && <LoadItems />}

                </tbody>
            </Table>
        </div >
    )
}